import { Box } from "@mui/material";
import { KronosTimerDialog, TimersDataGrid } from "../kronos-kit";

/**
 *
 * @returns {ReactElement} Timers page
 */
export function Timers() {
  return (
    <Box sx={{ p: 2, flex: 1, display: "flex" }}>
      <TimersDataGrid searchEnabled />
      <KronosTimerDialog />
    </Box>
  );
}
